import { z } from 'zod';

// Base city fee schema
export const CityFeeSchema = z.object({
  _id: z.string().optional(),
  city: z.string().min(1, 'City is required').trim(),
  state: z
    .string()
    .min(2, 'State is required')
    .max(2, 'State must be 2 characters')
    .trim()
    .toUpperCase(),
  feeInCents: z.number().int().min(0, 'Fee must be a positive number'),
  archived: z.boolean().default(false),
  organizationId: z.string().min(1, 'Organization ID is required'),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

// Schema for creating a city fee
export const CityFeeCreateSchema = z.object({
  city: z.string().min(1, 'City is required').trim(),
  state: z
    .string()
    .min(2, 'State is required')
    .max(2, 'State must be 2 characters')
    .trim()
    .toUpperCase(),
  feeInCents: z.number().int().min(0, 'Fee must be a positive number'),
  organizationId: z.string().min(1, 'Organization ID is required'),
  archived: z.boolean().optional().default(false),
});

// Schema for updating a city fee
export const CityFeeUpdateSchema = z.object({
  _id: z.string().min(1, 'City fee ID is required'),
  city: z.string().min(1, 'City is required').trim().optional(),
  state: z
    .string()
    .min(2, 'State is required')
    .max(2, 'State must be 2 characters')
    .trim()
    .toUpperCase()
    .optional(),
  feeInCents: z.number().int().min(0, 'Fee must be a positive number').optional(),
  archived: z.boolean().optional(),
  organizationId: z.string().min(1, 'Organization ID is required'),
});

// Schema for archiving/unarchiving a city fee
export const CityFeeArchiveSchema = z.object({
  _id: z.string().min(1, 'City fee ID is required'),
  organizationId: z.string().min(1, 'Organization ID is required'),
});

// Schema for listing city fees
export const CityFeeListSchema = z.object({
  organizationId: z.string().min(1, 'Organization ID is required'),
  includeArchived: z.boolean().optional().default(false),
  search: z.string().optional(),
});

// Schema for getting a single city fee
export const CityFeeGetByIdSchema = z.object({
  _id: z.string().min(1, 'City fee ID is required'),
  organizationId: z.string().min(1, 'Organization ID is required'),
});

// TypeScript types derived from schemas
export type CityFee = z.infer<typeof CityFeeSchema>;
export type CityFeeCreate = z.infer<typeof CityFeeCreateSchema>;
export type CityFeeUpdate = z.infer<typeof CityFeeUpdateSchema>;
export type CityFeeArchive = z.infer<typeof CityFeeArchiveSchema>;
export type CityFeeList = z.infer<typeof CityFeeListSchema>;
export type CityFeeGetById = z.infer<typeof CityFeeGetByIdSchema>;
